import { doc } from 'firebase/firestore'
import { useMemo } from 'react'
import { EnrollmentUser } from '../../../pure-js/types/GrooverTypes'
import { Collections } from '../../../pure-js/libs/Collections'
import { createUniqueId } from '../../../pure-js/libs/Common'
import { db } from '../libs/Firebase'
import { useFirestoreQuery } from './useFirestoreQuery'

/**
 * Real-time subscription to the logged-in portal customer's enrollment_users document.
 */
export const usePortalEnrollmentUser = (enrollmentUserId: string | null) => {
  const docRef = useMemo(() => {
    const placeholderId = createUniqueId()
    return doc(db, `${Collections.ENROLLMENT_USERS}/${enrollmentUserId || placeholderId}`)
  }, [enrollmentUserId])

  const { data, isLoading, error, status } = useFirestoreQuery<EnrollmentUser>(docRef, {
    fnName: 'usePortalEnrollmentUser',
    enabled: !!enrollmentUserId
  })

  return {
    enrollmentUser: enrollmentUserId ? data : null,
    isLoading: !!enrollmentUserId && isLoading,
    error,
    status
  }
}
